module.exports = __webpack_public_path__ + "static/media/smares_pos.1701edb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posts/smares_pos.jpg
// module id = 406
// module chunks = 0